import styled from "styled-components";

export const StyledContentTwoElementsChip = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 2px 10px;
`;
